import { Box, styled } from "@mui/material";

export const TreeViewWrapper = styled(Box)(() => ({
  "&.directory": {
    ".tree": {
      whiteSpace: "nowrap",
      scrollbarWidth: "thin",
      cursor: "pointer",
    },
  },
  ".icon": {
    verticalAlign: "middle",
    paddingRight: "5px",
    width: "1.2rem",
    height: "1.2rem",
  },
}));
